/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheatFlagHistoryEntry
 */
export interface CheatFlagHistoryEntry {
    /**
     * Whether this entry records a flag being applied or removed.
     * @type {string}
     * @memberof CheatFlagHistoryEntry
     */
    action: CheatFlagHistoryEntryActionEnum;
    /**
     * ObjectId of the admin who performed the transition.
     * @type {string}
     * @memberof CheatFlagHistoryEntry
     */
    by: string;
    /**
     * Unix ms timestamp of the transition.
     * @type {number}
     * @memberof CheatFlagHistoryEntry
     */
    at: number;
    /**
     * Free-text rationale captured at transition time. Required for both SET and CLEARED.
     * @type {string}
     * @memberof CheatFlagHistoryEntry
     */
    reason: string;
}


/**
 * @export
 */
export const CheatFlagHistoryEntryActionEnum = {
    SET: 'SET',
    CLEARED: 'CLEARED'
} as const;
export type CheatFlagHistoryEntryActionEnum = typeof CheatFlagHistoryEntryActionEnum[keyof typeof CheatFlagHistoryEntryActionEnum];


/**
 * Check if a given object implements the CheatFlagHistoryEntry interface.
 */
export function instanceOfCheatFlagHistoryEntry(value: object): value is CheatFlagHistoryEntry {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('by' in value) || value['by'] === undefined) return false;
    if (!('at' in value) || value['at'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function CheatFlagHistoryEntryFromJSON(json: any): CheatFlagHistoryEntry {
    return CheatFlagHistoryEntryFromJSONTyped(json, false);
}

export function CheatFlagHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheatFlagHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'by': json['by'],
        'at': json['at'],
        'reason': json['reason'],
    };
}

export function CheatFlagHistoryEntryToJSON(json: any): CheatFlagHistoryEntry {
    return CheatFlagHistoryEntryToJSONTyped(json, false);
}

export function CheatFlagHistoryEntryToJSONTyped(value?: CheatFlagHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'by': value['by'],
        'at': value['at'],
        'reason': value['reason'],
    };
}

